// Tipos para o catálogo de serviços e itens de OS

export type TipoPreco = 'fixo' | 'por_hora' | 'por_m2';

export interface Servico {
  id: string;
  nome: string;
  descricao: string;
  tipo_preco: TipoPreco;
  valor_base: number;
  unidade: string;
  duracao_padrao_minutos: number | null;
  ativo: boolean;
  criado_em: string;
  atualizado_em: string;
}

export interface ItemOS {
  id: string;
  ordem_servico_id: string;
  servico_id: string;
  servico_nome: string;
  quantidade: number;
  valor_unitario: number;
  valor_total: number;
  criado_em: string;
}

// Item selecionado no formulário (antes de salvar)
export interface ItemSelecionado {
  servico: Servico;
  quantidade: number;
}

import type { TFunction } from 'i18next';

// Labels para tipo de preço
export const getTipoPrecoLabels = (t: TFunction): Record<TipoPreco, string> => ({
  fixo: t('services.priceType.fixed'),
  por_hora: t('services.priceType.hourly'),
  por_m2: t('services.priceType.sqm'),
});

// Unidades padrão por tipo de preço
export const getUnidadePadrao = (t: TFunction): Record<TipoPreco, string> => ({
  fixo: t('services.defaultUnit.fixed'),
  por_hora: t('services.defaultUnit.hourly'),
  por_m2: t('services.defaultUnit.sqm'),
});

// Import + re-export centralizado para manter compatibilidade de import
import { formatarMoeda } from '@/lib/currency';
export { formatarMoeda as formatarValor };

// Calcular total de uma lista de itens. Serviços por_hora contam 0 — o valor é
// calculado pelo tempo de execução, não na criação.
export function calcularTotalItens(itens: ItemSelecionado[]): number {
  return itens.reduce((acc, item) => {
    if (item.servico.tipo_preco === 'por_hora') return acc;
    return acc + item.servico.valor_base * item.quantidade;
  }, 0);
}

// Formatar descrição do preço
export function formatarDescricaoPreco(servico: Servico, t: TFunction): string {
  const valor = formatarMoeda(servico.valor_base);

  switch (servico.tipo_preco) {
    case 'por_hora':
      return `${valor} / ${t('services.defaultUnit.hourly')}`;
    case 'por_m2':
      return `${valor} / ${t('services.defaultUnit.sqm')}`;
    default:
      return valor;
  }
}
